module.exports = __webpack_public_path__ + "static/media/multidexter.2f051619.jpg";